export const REPOSITORIES_QUERY_KEY = 'REPOSITORIES';
export const AVAILABLE_GIT_PROVIDERS_QUERY_KEY = 'AVAILABLE_GIT_PROVIDERS';
export const GIT_WORKSPACES_QUERY_KEY = 'GIT_WORKSPACES';
export const GIT_REPOSITORIES_QUERY_KEY = 'GIT_REPOSITORIES';

export const API_URLS = {
  Repositories: process.env.REACT_APP_REPOSITORIES_URL,
};
